// extracted by mini-css-extract-plugin
export default {"marge":"FormulaireCouche_marge__TieNK","especila":"FormulaireCouche_especila__YIdxD","center":"FormulaireCouche_center__rHXgi","stillers":"FormulaireCouche_stillers__ydT1j"};